module.exports = __webpack_public_path__ + "static/media/S1N13-2.ff258608.svg";